<div class="login-container">
  <div class="card">
    <div class="card-body text-center">
      <h2 class="card-title">Login</h2>
      <p class="card-text">Redirecting to login page...</p>
      <div *ngIf="loading" class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
